var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2.65618C11.4005 0.817671 8.7278 0.249492 6.72376 1.93301C4.71971 3.61653 4.43757 6.43128 6.01136 8.4224C7.31986 10.0778 11.2798 13.5694 12.5777 14.6995C12.7229 14.8259 12.7955 14.8891 12.8802 14.9139C12.9541 14.9356 13.0349 14.9356 13.1089 14.9139C13.1936 14.8891 13.2661 14.8259 13.4114 14.6995C14.7093 13.5694 18.6692 10.0778 19.9777 8.4224C21.5515 6.43128 21.3037 3.59882 19.2653 1.93301C17.2268 0.267202 14.5995 0.817671 13 2.65618Z",
    fill: "#EC1A3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2.65618C11.4005 0.817671 8.7278 0.249492 6.72376 1.93301C4.71971 3.61653 4.43757 6.43128 6.01136 8.4224C7.31986 10.0778 11.2798 13.5694 12.5777 14.6995C12.7229 14.8259 12.7955 14.8891 12.8802 14.9139C12.9541 14.9356 13.0349 14.9356 13.1089 14.9139C13.1936 14.8891 13.2661 14.8259 13.4114 14.6995C14.7093 13.5694 18.6692 10.0778 19.9777 8.4224C21.5515 6.43128 21.3037 3.59882 19.2653 1.93301C17.2268 0.267202 14.5995 0.817671 13 2.65618Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedHeart);
export default __webpack_public_path__ + "static/media/red-heart.1e37dc7feacad912fc9296abd8c691a9.svg";
export { ForwardRef as ReactComponent };